import React from 'react';
import { Skeleton } from 'antd';

const App: React.FC = () => <Skeleton active paragraph={{ rows: 24 }} />;

export default App;